"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClient = void 0;
/**
 * Detects if code is running on the client through presence of the window object.
 *
 * @returns
 */
var isClient = exports.isClient = function isClient() {
  return typeof window !== 'undefined';
};